import {useEffect, useState} from 'react'
import { CardContent, Grid, Typography, IconButton, Tooltip } from '@mui/material';
import CircularIndeterminate from "../../../../components/circularProgress";
import InfoIcon from "@mui/icons-material/Info";
import StyledCard from "../../../../components/StyledCard";




const EntropyCard = ({value, threesholds, title, infoText, charged = false}) => {
    const [color, setColor] = useState("")

    useEffect(() => {
        const color = value < threesholds[0] ? "#C9B85E" : value >= threesholds[0] && value <= threesholds[1] ? "#67BBBC" : value > threesholds[1] ? "#615421" : ""
        setColor(color)
    }, [value, threesholds])

    return (
        <StyledCard>
            <CardContent>
                <Grid container spacing={2}>
                <Grid size={12} style={{marginBottom: 2, display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }} >
                <Typography style={{fontWeight: 600, fontSize: 12}}>ENTROPY ANALYSIS FOR {title}</Typography> 
                {infoText && (
                            <Tooltip
                              title={
                                <Typography variant="body2" sx={{ fontSize: 15, padding: '0.5rem' }}>
                                  {infoText}
                                </Typography>
                              }
                              sx={{ justifyContent: "left" }}
                            >
                              <IconButton
                                sx={{
                                  backgroundColor: "#3f3f3f",
                                  "&:hover": { backgroundColor: "#606060" },
                                }}
                              >
                                <InfoIcon sx={{ fontSize: 15 }} />
                              </IconButton>
                            </Tooltip>
                        )}
                </Grid>
                    <Grid size={6} style={{ display: "flex", alignItems: "center", justifyContent:"center"}}>
                        <Typography style={{fontWeight: 600, fontSize: 16, color: color}}>{value ? value : <CircularIndeterminate charged={charged} title="No data" />}</Typography>
                    </Grid>
                    <Grid size={6} style={{ display: "flex", alignItems: "center", justifyContent:"center"}}>
                    <Typography style={{fontWeight: 600, fontSize: 14}}>
                        {value < threesholds[0] ? "CENTRALISED" : value >= threesholds[0] && value <= threesholds[1] ? "NORMAL" : value > threesholds[1] ? "DISTRIBUTED" : "" }
                    </Typography>
                    </Grid>
                </Grid>
            </CardContent>
        </StyledCard>
    )
}

export default EntropyCard